import '../sass/highlights.scss';

(() => {
    const swiperScript = document.querySelector('#blenheim-schools-swiper-js');
    const $blocks = document.querySelectorAll('.block.highlights');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $textCarousel = $block.querySelector('.highlights__highlights-text');
        const $mediaCarousel = $block.querySelector('.highlights__highlights-media');
        const $labels = $block.querySelectorAll('.highlights__highlights-label');

        const initCarousels = () => {
            let textCarousel, mediaCarousel;

            if ($textCarousel) {
                textCarousel = new Swiper($textCarousel, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    autoHeight: true,
                    breakpoints: {
                        1024: {
                            autoHeight: false,
                        }
                    },
                    allowTouchMove: false,
                });
            }

            if ($mediaCarousel) {
                mediaCarousel = new Swiper($mediaCarousel, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    breakpoints: {
                        1024: {
                            autoHeight: false,
                        }
                    },
                    allowTouchMove: false,
                });
            }

            if ($labels) {
                $labels.forEach($label => {
                    $label.addEventListener('click', () => {
                        const { index } = $label.dataset;

                        $labels.forEach($label => {
                            $label.classList.remove('highlights__highlights-label--active');
                        });

                        $label.classList.add('highlights__highlights-label--active');

                        if (textCarousel) {
                            textCarousel?.slideTo(index);
                        }

                        if (mediaCarousel) {
                            mediaCarousel?.slideTo(index);
                        }
                    });
                })
            }
        };

        if (typeof Swiper !== 'undefined') {
            initCarousels();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousels();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#blenheim-schools-swiper-js');

                if (!swiperScript) return;

                initCarousels();
            });
        }
    });
})();
